// Generated by purs version 0.13.8
"use strict";
var Control_Monad_Reader = require("../Control.Monad.Reader/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Control_Monad_Writer_Trans = require("../Control.Monad.Writer.Trans/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Lens_Iso_Newtype = require("../Data.Lens.Iso.Newtype/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Lunarbox_Data_Dataflow_Runtime_TermEnvironment = require("../Lunarbox.Data.Dataflow.Runtime.TermEnvironment/index.js");
var Lunarbox_Data_Dataflow_Runtime_ValueMap = require("../Lunarbox.Data.Dataflow.Runtime.ValueMap/index.js");
var InterpreterContext = function (x) {
    return x;
};
var Interpreter = function (x) {
    return x;
};
var runInterpreter = function (dictOrd) {
    return function (context) {
        return function (v) {
            return Control_Monad_Reader.runReader(Control_Monad_Writer_Trans.runWriterT(v))(context);
        };
    };
};
var newtypeInterpreterContent = new Data_Newtype.Newtype(function (n) {
    return n;
}, InterpreterContext);
var newtypeInterpreter = new Data_Newtype.Newtype(function (n) {
    return n;
}, Interpreter);
var monadWriterInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.monadWriterWriterT(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(dictOrd))(Control_Monad_Reader_Trans.monadReaderT(Data_Identity.monadIdentity));
};
var monadTellInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.monadTellWriterT(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(dictOrd))(Control_Monad_Reader_Trans.monadReaderT(Data_Identity.monadIdentity));
};
var monadReaderInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.monadReaderWriterT(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(dictOrd))(Control_Monad_Reader_Trans.monadReaderReaderT(Data_Identity.monadIdentity));
};
var monadInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.monadWriterT(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(dictOrd))(Control_Monad_Reader_Trans.monadReaderT(Data_Identity.monadIdentity));
};
var monadAskInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.monadAskWriterT(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(dictOrd))(Control_Monad_Reader_Trans.monadAskReaderT(Data_Identity.monadIdentity));
};
var functorInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.functorWriterT(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity));
};
var execInterpreter = function (dictOrd) {
    return function (ctx) {
        var $27 = runInterpreter(dictOrd)(ctx);
        return function ($28) {
            return Data_Tuple.snd($27($28));
        };
    };
};
var evalInterpreter = function (dictOrd) {
    return function (ctx) {
        var $29 = runInterpreter(dictOrd)(ctx);
        return function ($30) {
            return Data_Tuple.fst($29($30));
        };
    };
};
var defInterpreterContext = function (dictDefault) {
    return function (dictOrd) {
        return new Data_Default.Default({
            location: Data_Default.def(dictDefault),
            termEnv: Data_Monoid.mempty(Lunarbox_Data_Dataflow_Runtime_TermEnvironment.monoidTermEnvironment),
            overwrites: Data_Monoid.mempty(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(dictOrd)),
            toplevel: true
        });
    };
};
var bindInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.bindWriterT(Lunarbox_Data_Dataflow_Runtime_ValueMap.semigroupValueMap(dictOrd))(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity));
};
var applyInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.applyWriterT(Lunarbox_Data_Dataflow_Runtime_ValueMap.semigroupValueMap(dictOrd))(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity));
};
var applicativeInterpreter = function (dictOrd) {
    return Control_Monad_Writer_Trans.applicativeWriterT(Lunarbox_Data_Dataflow_Runtime_ValueMap.monoidValueMap(dictOrd))(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity));
};
var _toplevel = function (dictStrong) {
    var $31 = Data_Lens_Iso_Newtype["_Newtype"](newtypeInterpreterContent)(newtypeInterpreterContent)(dictStrong.Profunctor0());
    var $32 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "toplevel";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($33) {
        return $31($32($33));
    };
};
var _termEnv = function (dictStrong) {
    var $34 = Data_Lens_Iso_Newtype["_Newtype"](newtypeInterpreterContent)(newtypeInterpreterContent)(dictStrong.Profunctor0());
    var $35 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "termEnv";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($36) {
        return $34($35($36));
    };
};
var _overwrites = function (dictStrong) {
    var $37 = Data_Lens_Iso_Newtype["_Newtype"](newtypeInterpreterContent)(newtypeInterpreterContent)(dictStrong.Profunctor0());
    var $38 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "overwrites";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($39) {
        return $37($38($39));
    };
};
var _location = function (dictStrong) {
    var $40 = Data_Lens_Iso_Newtype["_Newtype"](newtypeInterpreterContent)(newtypeInterpreterContent)(dictStrong.Profunctor0());
    var $41 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "location";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($42) {
        return $40($41($42));
    };
};
module.exports = {
    Interpreter: Interpreter,
    InterpreterContext: InterpreterContext,
    runInterpreter: runInterpreter,
    execInterpreter: execInterpreter,
    evalInterpreter: evalInterpreter,
    "_location": _location,
    "_termEnv": _termEnv,
    "_overwrites": _overwrites,
    "_toplevel": _toplevel,
    defInterpreterContext: defInterpreterContext,
    newtypeInterpreterContent: newtypeInterpreterContent,
    newtypeInterpreter: newtypeInterpreter,
    functorInterpreter: functorInterpreter,
    applyInterpreter: applyInterpreter,
    applicativeInterpreter: applicativeInterpreter,
    bindInterpreter: bindInterpreter,
    monadInterpreter: monadInterpreter,
    monadAskInterpreter: monadAskInterpreter,
    monadReaderInterpreter: monadReaderInterpreter,
    monadTellInterpreter: monadTellInterpreter,
    monadWriterInterpreter: monadWriterInterpreter
};
